module.exports = __webpack_public_path__ + "img/201705-3-1024x1024.854ab097.jpeg";